<template>
  <v-combobox
    v-model="select"
    :items="items"
    item-text="descricao"
    item-value="id"
    :label="label"
    :multiple="multiple"
    :disabled="disabled"
    :color="color"
    @input="$emit('input', select)"
    @change="this.change"
  />
</template>

 <script>
    import GrupoService from "../services/grupoService"
    export default {
        props: {
            multiple: Boolean,
            object: Object,
            exibirTodos: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            color: {
                type: String,
                default: "black"
            },
            label: {
                type: String,
                default: "Selecione o tipo de publicação"
            },
            change: {
                type: Function,
                default: () => {}
            }
        },
        data() {
            return {
                select: [],
                items: []
            };
        },
        methods: {
            async carregarGrupos() {
                const res = await GrupoService.listarGrupo();
                this.items = res.data.data.listarGrupo.filter(g => g.descricao !== 'Anúncio');

                if (this.exibirTodos) {
                  this.items.unshift({
                    id: null,
                    descricao: "Todos"
                  });
                }

                if (this.$utils.isNotNull(this.object)) {
                  this.select = this.object;
                } else {
                  this.select = null;
                }
            }
        },
        created() {
            this.carregarGrupos();
        }
    };
</script>

<style>
</style>
